interface GetLogoPathParams {
  hasOnlyTelehealth: boolean;
  hasOnlyChat: boolean;
  hasOnlyRecallUpload: boolean;
  hasNoAccessToActivityFeed: boolean;
}
export const getLogoPath = (options: GetLogoPathParams) => {
  if (options.hasOnlyTelehealth) {
    return '/schedule';
  }
  if (options.hasOnlyChat) {
    return '/hub';
  }
  if (options.hasOnlyRecallUpload || options.hasNoAccessToActivityFeed) {
    return '/patients';
  }
  return '/';
};
